import { Form, RHFTextField } from '@/components'
import { Grid, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

interface FormHeightAndWeightProps {
  methods: any
  onSubmit: any
}
export const FormHeightAndWeight = ({ methods, onSubmit }: FormHeightAndWeightProps) => {
  const t = useTranslations()

  return (
    <Form methods={methods} onSubmit={onSubmit}>
      <Grid spacing={1} container>
        <Grid size={{xs: 12, sm: 6}}>
          <RHFTextField
            slotProps={{
              input: {
                endAdornment: (
                  <Typography fontSize={{ xs: '0.875rem', md: '1rem' }} fontWeight={300}>
                    cm
                  </Typography>
                ),
              },
            }}
            name="height"
            label={`${t('Chiều cao')}: `}
            placeholder={'0'}
            type="number"
          />
        </Grid>{' '}
        <Grid size={{xs: 12, sm: 6}}>
          <RHFTextField
            slotProps={{
              input: {
                endAdornment: (
                  <Typography fontSize={{ xs: '0.875rem', md: '1rem' }} fontWeight={300}>
                    kg
                  </Typography>
                ),
              },
            }}
            name="weight"
            label={`${t('Cân nặng')}: `}
            placeholder={'0'}
            type="number"
          />
        </Grid>
      </Grid>
    </Form>
  )
}
